import styled from "styled-components";
import {Button} from "antd";
import {PRIMARY_COLOR} from "../../../colors";
import {Link} from "react-router-dom";

export const StyledButton = styled(Button)`
  width: 100%;
  border-radius: 25px;
  border: none;
`;